import { render } from "./DocumentsGeneral..vue?vue&type=template&id=b1ac7018&scoped=true"
import script from "./DocumentsGeneral..vue?vue&type=script&lang=js"
export * from "./DocumentsGeneral..vue?vue&type=script&lang=js"

import "./DocumentsGeneral..vue?vue&type=style&index=0&id=b1ac7018&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ac7018"]])

export default __exports__